export default {
  home: {
    title: "Digital nettverkssamling i Trøndelag",
    subTitle: "matematikk og fysikk",
    date: "23. november 2020",
    text1: `Velkommen til årets samling for nettverkene i matematikk og fysikk i Trøndelag, som på grunn av koronarrestriksjoner avholdes digital. Bruk gjerne både kamera og mikrofon og logg deg på via arbeids-pc. Dere møter opp på egen arbeidsplass og oppfordres til aktiv deltakelse i diskusjoner.`,
    text2: `Samlingen er aktuell for alle lærere som underviser i matematikk og fysikk, og kan være aktuell for avdelingsledere som er ansvarlige for realfag og rådgivere innenfor eksamenssektor. Samlingen i år vil ha fokus på blant annet fagfornyelsen og eksamen.`,
    text3: `Lærere som underviser i flere realfag kan velge mellom foredrag innen ulike fagdisipliner.`,
    text4: `Det er ingen kursavgift.`,

    subText1: `Påmeldingsfrist er 1. november. Alle må registrere seg.`,
    subText2: `Ansvarlig nettverksleder: Dmytro ****, e-post`,
    mail: "dm******",
  },

  speakers: {
    title: "Ola Hansen, Universitetslektor ved Nasjonalt senter for hjernetrim",
    text: `Ola hansen er rett og slett dummytekst fra og for trykkeindustrien. Lorem Ipsum har vært bransjens standard for dummytekst helt siden 1500-tallet, 
      da en ukjent boktrykker stokket en mengde bokstaver for å lage et prøveeksemplar av en bok.
      Lorem Ipsum har tålt tidens tann usedvanlig godt, og har i tillegg til å bestå gjennom fem århundrer også tålt spranget over til elektronisk typografi uten vesentlige endringer. 
      Lorem Ipsum ble gjort allment kjent i 1960-årene ved lanseringen av Letraset-ark med avsnitt fra Lorem Ipsum, og senere med sideombrekkingsprogrammet Aldus PageMaker som tok i bruk nettopp
      Lorem Ipsum for dummytekst.
      `,

    bigText: `
      Lorem Ipsum er rett og slett dummytekst fra og for trykkeindustrien. Lorem Ipsum har vært bransjens standard for dummytekst helt siden 1500-tallet, 
      da en ukjent boktrykker stokket en mengde bokstaver for å lage et prøveeksemplar av en bok.
      Lorem Ipsum har tålt tidens tann usedvanlig godt, og har i tillegg til å bestå gjennom fem århundrer 
      også tålt spranget over til elektronisk typografi uten vesentlige endringer. 
      Lorem Ipsum ble gjort allment kjent i 1960-årene ved lanseringen av Letraset-ark med avsnitt fra Lorem Ipsum, 
      og senere med sideombrekkingsprogrammet Aldus PageMaker som tok i bruk nettopp Lorem Ipsum for dummetekst. 

      Lorem Ipsum er rett og slett dummytekst fra og for trykkeindustrien. Lorem Ipsum har vært bransjens standard for dummytekst helt siden 1500-tallet, 
      da en ukjent boktrykker stokket en mengde bokstaver for å lage et prøveeksemplar av en bok.
      Lorem Ipsum har tålt tidens tann usedvanlig godt, og har i tillegg til å bestå gjennom fem århundrer 
      også tålt spranget over til elektronisk typografi uten vesentlige endringer. 
      Lorem Ipsum ble gjort allment kjent i 1960-årene ved lanseringen av Letraset-ark med avsnitt fra Lorem Ipsum, 
      og senere med sideombrekkingsprogrammet Aldus PageMaker som tok i bruk nettopp Lorem Ipsum for dummetekst. 
      `,
  },

  form: {
    title: "Påmelding til faglig-pedagogisk dag",
  },
};
